import { merge } from 'lodash';
import { useMemo } from 'react';

import { ActivityThemeStyles, defaultActivityThemeStyles } from 'external-modules/ui';

import { useCurrentDocument } from '@/components/YjsProvider';
import { getThemeDefaultValue } from '@/contentObjects/Root/ActivityThemeStylesUtils';
import { useActivityThemeStylesProperty } from '@/contentObjects/Root/hooks/useActivityThemeStylesProperty';
import { useParentTheme } from '@/contentObjects/Root/hooks/useParentTheme';
import { useObservedProperty } from '@/utils/yjs';

export function useTooltipResolvedStyles(styles?: Partial<ActivityThemeStyles['tooltip']>) {
  const document = useCurrentDocument();
  const [tooltipStyles] = useActivityThemeStylesProperty<ActivityThemeStyles['tooltip']>(document, 'tooltip');

  const [activityThemeStyles] = useObservedProperty<Partial<ActivityThemeStyles>>(
    document.getMap('root'),
    'activityThemeStyles'
  );
  const { data: parentTheme } = useParentTheme();
  const tooltipDefaultStyles: ActivityThemeStyles['tooltip'] = useMemo(
    () => getThemeDefaultValue(activityThemeStyles, parentTheme?.styles, defaultActivityThemeStyles, 'tooltip'),
    [activityThemeStyles, parentTheme?.styles]
  );

  return useMemo(
    () => merge({}, tooltipDefaultStyles, tooltipStyles, styles),
    [styles, tooltipDefaultStyles, tooltipStyles]
  );
}
